import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

const PATHS = {
  "Sentry": "/sentry",
  "Observatory": "/observatory",
  "Pricing": "/pricing",
  "Docs": "/docs",
  "Blog": "/blog",
  "EU AI Act": "/compliance",
  "NIST AI RMF": "/compliance",
  "SOC 2": "/compliance",
  "HIPAA": "/compliance",
  "FedRAMP": "/compliance",
  "Contact": "/contact",
};

export default function Footer() {
  return (
    <footer data-testid="marketing-footer" className="border-t border-[rgba(17,30,51,0.08)] mt-24 bg-[#EFEAE1]">
      <div className="container-x py-16 grid md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <Logo variant="light" />
          <p className="ink mt-4 text-sm max-w-sm">
            The governance OS for regulated AI. Every request screened. Every decision logged. Every policy reproducible.
          </p>
          <div className="flex gap-2 mt-6">
            <span className="chip chip-navy">SOC 2</span>
            <span className="chip chip-navy">HIPAA</span>
            <span className="chip chip-navy">EU AI Act</span>
            <span className="chip chip-navy">FedRAMP</span>
          </div>
        </div>
        {[
          { title: "Product", items: ["Sentry", "Observatory", "Pricing", "Docs", "Blog"] },
          { title: "Compliance", items: ["EU AI Act", "NIST AI RMF", "SOC 2", "HIPAA", "FedRAMP"] },
          { title: "Company", items: ["About", "Careers", "Security", "Contact"] },
        ].map(col => (
          <div key={col.title}>
            <div className="eyebrow text-navy/70 mb-3">{col.title}</div>
            <ul className="space-y-2 text-sm">
              {col.items.map(x => {
                const to = PATHS[x];
                return (
                  <li key={x}>
                    {to
                      ? <Link to={to} className="ink hover:text-navy">{x}</Link>
                      : <span className="ink/70">{x}</span>}
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-[rgba(17,30,51,0.08)]">
        <div className="container-x py-6 flex flex-wrap items-center justify-between text-xs ink">
          <div>© 2026 Lunar Occultation, Inc. All rights reserved.</div>
          <div className="flex gap-5">
            <a href="#" className="hover:text-navy">Privacy</a>
            <a href="#" className="hover:text-navy">Terms</a>
            <a href="#" className="hover:text-navy">Trust</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
